import React from 'react';
import StarFilledIcon from './star-filled';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ShortlistedIcon(props) {
  return ___EmotionJSX(StarFilledIcon, props);
}